export default __webpack_public_path__ + "static/media/image-about-mission-w@3x.7ced5988.webp";